import { render, staticRenderFns } from "./MyActivityBadges.vue?vue&type=template&id=0a45ad5a"
import script from "./MyActivityBadges.vue?vue&type=script&lang=js"
export * from "./MyActivityBadges.vue?vue&type=script&lang=js"
import style0 from "./MyActivityBadges.vue?vue&type=style&index=0&id=0a45ad5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports